import axios from 'axios';
import host from './Host';
import helpers from './helper';
const axiosInstance = axios.create({
  baseURL: host, // Replace with your API base URL
});

// Add a response interceptor to check for token expiration
axiosInstance.interceptors.response.use(
  (response) => {
    helpers.handleCheckTokenValid(response)
    return response;
  },
  (error) => {
    console.log('Error: ',error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
